import React from 'react';
import { LAYER } from '../../../propTypes';

const SVGLayer = ({ tag: Tag, ...layerProps }) => {
    const { childElements, ...props } = layerProps;
    if (childElements) {
        props.children = childElements.map(({ layerId, ...child }) => <SVGLayer key={layerId} {...child} />);
    }

    return <Tag {...props} />;
};

SVGLayer.propTypes = {
    ...LAYER,
};

export default SVGLayer;
